import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const contractsAgreementParametersAdapter = getAdapter({ idFieldName: 'value' });

const contractsAgreementParametersSlice = createSlice({
  name: 'contractsAgreementParameters',
  initialState: contractsAgreementParametersAdapter.getInitialState(),
  reducers: {
    setContractsAgreementParameters: (state, { payload: { contractsAgreementParameters } }) => {
      contractsAgreementParametersAdapter.setAll(state, contractsAgreementParameters);
    }
  }
});

const selectors = contractsAgreementParametersAdapter.getSelectors(({ contractsAgreementParameters }) => contractsAgreementParameters);

export const getContractsAgreementParameters = state => selectors.selectAll(state);

export const { setContractsAgreementParameters } = contractsAgreementParametersSlice.actions;

export default contractsAgreementParametersSlice.reducer;
